import request from '@/utils/request'

// 查询月卡泊位订单记录列表
export function listOrder(query) {
  return request({
    url: '/parking/monthlycardorder/list',
    method: 'get',
    params: query
  })
}

// 查询月卡泊位订单记录详细
export function getOrder(id) {
  return request({
    url: '/parking/monthlycardorder/' + id,
    method: 'get'
  })
}

// 新增月卡泊位订单记录
export function addOrder(data) {
  return request({
    url: '/parking/monthlycardorder',
    method: 'post',
    data: data
  })
}

// 修改月卡泊位订单记录
export function updateOrder(data) {
  return request({
    url: '/parking/monthlycardorder',
    method: 'put',
    data: data
  })
}

// 删除月卡泊位订单记录
export function delOrder(id) {
  return request({
    url: '/parking/monthlycardorder/' + id,
    method: 'delete'
  })
}

// Query list of my active/paid monthly card orders
export function getMyActiveMonthlyCardOrders(query) {
  return request({
    url: '/parking/monthlycardorder/myActiveList',
    method: 'get',
    params: query
  })
}